import { useField } from 'formik';
import { DemographicFormData } from '../../../../util/demographics';

import FormSearchSelectInputV2 from '../../../common/forms/FormSearchSelectInputV2';

export const CountrySelect = () => {
  const [countryListOptions] =
    useField<DemographicFormData['countryListOptions']>('countryListOptions');
  return (
    <FormSearchSelectInputV2
      name="selectedCountry"
      options={countryListOptions.value}
    />
  );
};
